import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ReportInfo, ReportView } from './models/report.model';
import { ViewTemplate, ViewTemplateCatalog } from './models/template.model';
import { ReportExportViewService } from './report-export-view.service';
import { ReportExportConfigurations, REPORT_EXPORT_CONFIGS_TOKEN } from './report-export-view.token';
import {
  SelectTemplateDialogComponent,
  SelectTemplateDialogInputData,
} from './shared/select-template-dialog/select-template-dialog.component';
import { NotificationService } from './shared/services/notification.service';
import { HttpMethods } from './shared/utils/http-methods.class';
import { LOCALE_VIEW_TEMPLATE_ASSOCIATIONS } from './shared/constants/template.const';

@Injectable()
export class TemplateDynamicService extends HttpMethods {
  private allViewTemplates: { [viewId: number]: ViewTemplateCatalog };
  viewsWithSelectedTemplatedId = {};

  constructor(
    @Inject(REPORT_EXPORT_CONFIGS_TOKEN) moduleConfig: ReportExportConfigurations,
    httpClient: HttpClient,
    protected reportExportViewService: ReportExportViewService,
    private notificationService: NotificationService
  ) {
    super(moduleConfig.baseUrl, httpClient);
  }

  setReportTemplates(viewId: number, templates: ViewTemplateCatalog) {
    this.allViewTemplates = { ...this.allViewTemplates, [viewId]: templates };
  }

  getReportTemplates(viewId: number) {
    return this.allViewTemplates[viewId] ? this.allViewTemplates[viewId] : [];
  }

  setTemplateId(viewId: number, templateId: number) {
    this.viewsWithSelectedTemplatedId[viewId] = templateId;
  }

  getSelectedTemplateInfo(viewId: number) {
    return this.viewsWithSelectedTemplatedId[viewId];
  }

  public getTemplates(view: ReportView): Observable<ViewTemplateCatalog> {
    return this.reportExportViewService.getViewTemplateFieldsCatalog(view.catalogUri).pipe(
      map((templates: ViewTemplateCatalog) => {
        this.setReportTemplates(view.id, templates);
        return templates;
      })
    );
  }

  public templateDialog(reportId: number, viewId: number) {
    const dialogInputData: SelectTemplateDialogInputData = {
      reportId,
      templates: this.allViewTemplates[viewId],
      viewId,
    };
    return this.notificationService
      .openDialog<number>(SelectTemplateDialogComponent, dialogInputData)
      .pipe(filter((selectedTemplate: number) => selectedTemplate != null));
  }

  public saveAssociatedTemplates(reportData: ReportInfo, viewsAndSelectedTemplates: ViewTemplate) {
    return this.reportExportViewService.saveTemplate(
      reportData.reportId,
      viewsAndSelectedTemplates.viewId,
      viewsAndSelectedTemplates
    );
  }

  public setViewandTemplate(reportLocale: number, currentView: ReportView, selectedTemplateId: number) {
    if (!LOCALE_VIEW_TEMPLATE_ASSOCIATIONS[reportLocale]) {
      return [];
    }
    const viewsAndSelectedTemplates = [];
    const selectedView = LOCALE_VIEW_TEMPLATE_ASSOCIATIONS[reportLocale].filter(item =>
      Object.keys(item)[0].includes(currentView.id.toString())
    );
    if (selectedView && selectedView.length) {
      // get the index of Selected Template, same index(Office, Retail, Industrial) will be used in all views.
      const selectedTemplateIndex = selectedView[0][Object.keys(selectedView[0])].findIndex(
        templateItem => templateItem === selectedTemplateId
      );
      const allViewTemplateIds = LOCALE_VIEW_TEMPLATE_ASSOCIATIONS[reportLocale].map(item => {
        return {
          viewId: Object.keys(item)[0],
          templateId: Object.values(item)[0][selectedTemplateIndex],
        };
      });

      allViewTemplateIds.forEach(selectedViwandTemplateId => {
        let templateDetails = this.getReportTemplates(+selectedViwandTemplateId.viewId);
        templateDetails = templateDetails.map(item => {
          if (!item.viewId) {
            item.viewId = +selectedViwandTemplateId.viewId;
          }
          return item;
        });
        const selectedFilters = templateDetails.filter(itemForTemplates => {
          return itemForTemplates.templateId === selectedViwandTemplateId.templateId;
        });
        if (selectedFilters.length) {
          viewsAndSelectedTemplates.push(selectedFilters[0]);
        }
      });
    }
    return viewsAndSelectedTemplates;
  }
}
